export const accessControl = {
  inject: ["currentUser"],
  methods: {
    policy(policy) {
      return this.currentUser.user.current_user_policies[policy] || false;
    },
  },
};
